import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '@app/core';
import { CommonService } from '@app/core/services/common.service';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
@Component({
  selector: 'app-subscription',
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.scss'],
})
export class SubscriptionComponent implements OnInit {
  paymentHandler: any = null;
  loginForm: FormGroup;
  submitted = false;
  @Input() Popup = false;
  constructor(
    public _user: UserService,
    private _builder: FormBuilder,
    private _ga: GoogleAnalyticsService,
    private _activated: ActivatedRoute,
    private _common: CommonService
  ) {
    this._common.checkRouterData(this._activated.snapshot.data);
    this.loginForm = this._builder.group({
      email: ['', [Validators.required, Validators.email]],
      password: [''],
      userId: [''],
      priceId: ['', Validators.required],
    });
  }

  ngOnInit() {
  }

  async postData(priceId: string, trial = 0) {
    let user = this._user.authUser.getValue();
    const params: any = { priceId: priceId };
    if (trial) {
      params['trial'] = trial;
    }
    if (user) {
      params['email'] = user.email;
      params['userId'] = user.id;
    }
    const form = document.createElement('form');
    form.method = 'post';
    form.action = 'https://kingpin.pro/subscribe';
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        const hiddenField = document.createElement('input');
        hiddenField.type = 'hidden';
        hiddenField.name = key;
        hiddenField.value = params[key];
        form.appendChild(hiddenField);
      }
    }
    document.body.appendChild(form);
    form.submit();
  }
}
